import React, { Fragment, useState, useEffect } from "react";

import { useTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
import Cookies from "js-cookie";
import axios from "axios";

import "react-toastify/dist/ReactToastify.css";
import { color } from "framer-motion";
const { config } = require("../../api/api");

function SanadOmanVisaSummary({ data, docFiles, setActiveTab, onBack }) {


  const [formData, setFormData] = useState(data);

  const [isLoading, setIsLoading] = useState(false);
  const [vendorKey, setVendorKey] = useState(
    "c3VwZXJqZXRfc2FuYWRfcGVyc29uYWxfYWNjaWRlbnRfdmVuZG9yX2tleQ=="
  );
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState(docFiles);
  const [appId, setAppId] = useState("");
  const base_url = config.baseURL;

  // ✅ Load SmartBox script

  const openPaymentGateway = async (app_id) => {
    if (!app_id || !vendorKey) {
      console.error(" Missing appId or vendorKey");
      return;
    }

    setLoading(true);

    const pay_data = {
      application_id: app_id,
      is_live: "true",
      save_selection: "true",
      currency: "OMR",
      fee_omr: 45,
      description: "Oman Visa Payment",
    };

    try {
      const res = await fetch(`${base_url}/create_sanad_oman_visa_payment`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${vendorKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(pay_data),
      });

      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

      const result = await res.json();
      if (result.message === "success") {
        const parsedata = JSON.parse(result.result.payment_details);
        const { secureHash, trxParams } = parsedata;

        if (!window.SmartBox || !window.SmartBox.Checkout) {
          throw new Error("SmartBox payment gateway not loaded");
        }
       

        window.SmartBox.Checkout.configure = {
          MID: trxParams.MerchantId,
          TID: trxParams.TerminalId,
          CurrencyId: trxParams.CurrencyId,
          AmountTrxn: trxParams.Amount,
          MerchantReference: trxParams.MerchantReference,
          LanguageId: "en",
          PaymentViewType: 1,
          TrxDateTime: trxParams.TrxDateTime,
          SessionToken: trxParams.SessionToken,
          SecureHash: secureHash,

          completeCallback: async (data) => {
            try {
              setLoading(true);
              const verifyRes = await axios.post(
                `${base_url}/sanad_oman_visa_payment_status`,
                data.data
              );
              if (verifyRes.data.valid) {
                window.location.href = verifyRes.data.data;
                return;
              }
            } catch (err) {
              setLoading(false);
              console.error("Verification failed:", err);
            }
          },

          errorCallback: (error) => {
            console.error("❌ Payment Error:", error);
            setLoading(true);
            window.location.href = `/sanad-oman-visa-status?application_id=${btoa(
              app_id
            )}&payment_status=failed`;
          },

          cancelCallback: () => {
            console.log("⚠️ Payment Cancelled:");
            setLoading(false);
          },
        };

        window.SmartBox.Checkout.showSmartBox();
      } else {
        throw new Error(result.message || "Payment creation failed");
      }
    } catch (err) {
      console.error("Error creating payment:", err);
      toast.error(err.message);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const fieldName = e.target.name;

    if (!file) return;

    // Validate file type
    const allowedTypes =
      fieldName === "supportingDocs"
        ? ["application/pdf", "image/jpeg", "image/jpg", "image/png"]
        : fieldName === "passportCopy"
        ? ["application/pdf", "image/jpeg", "image/jpg", "image/png"]
        : ["image/jpeg", "image/jpg", "image/png"];

    if (!allowedTypes.includes(file.type)) {
      toast.error(
        `Invalid file type. Please upload ${
          fieldName === "passportCopy" || fieldName === "supportingDocs"
            ? "PDF, JPG, or PNG"
            : "JPG or PNG"
        } files only.`
      );
      e.target.value = "";
      return;
    }

    // Validate file size
    const maxSize =
      fieldName === "passportCopy" || fieldName === "supportingDocs"
        ? 10 * 1024 * 1024
        : 5 * 1024 * 1024; // 10MB or 5MB
    if (file.size > maxSize) {
      toast.error(
        `File size too large. Maximum size is ${
          fieldName === "passportCopy" || fieldName === "supportingDocs"
            ? "10MB"
            : "5MB"
        }.`
      );
      e.target.value = "";
      return;
    }

    setFiles({
      ...files,
      [fieldName]: file,
    });

    // toast.success(`${fieldName} uploaded successfully!`);
  };

  const handleClickBtnFile = (e, fieldName) => {
    document.getElementById(fieldName).click();
  };

  const handleMakePayment = async (e) => {
   
    e.preventDefault();
    if (!formData) {
      alert("No form data found. Please fill the form first.");
      return;
    }

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      var uploaded_document_details = [];

       const file_keys= Object.keys(files);
      for(let k=0;k<file_keys.length;k++){

        const each_file=files[file_keys[k]];

          const file_name=each_file?.name;
          if(file_name){
          // const extension=file_name.substring(file_name.lastIndexOf('.')).toLowerCase();
          const fileData=new FormData();
          fileData.append("image",each_file);
          fileData.append("document_type",file_keys[k])
          const response = await fetch(base_url+'/upload_documentss3',{
            method:"POST",
            headers:{
              "Authorization":"Bearer "+vendorKey
            },
            body:fileData
          })
          if(response.ok){
          const data=await response.json();
          if(data.message==="File uploaded successfully"){
            //  const get_card_details=localStorage.getItem("added_card_details");
            //  const parse_card=get_card_details && JSON.parse(get_card_details);
          const obj={
              document_type:file_keys[k],
              document: data.fileUrl
          }
          uploaded_document_details.push(obj);
          }
          }
        }
      }

      const payload = {
        ...formData,
        uploadedDocuments: JSON.stringify(uploaded_document_details),
      };

      const response = await fetch(base_url + "/create_sanad_oman_visa_form", {
        method: "POST",
        headers: {
          Authorization: "Bearer " + vendorKey,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

    
      const data = await response.json();
      if (data.message === "success") {
        if (data.result && data.result.application_id) {
          const app_id = data.result.application_id;

          openPaymentGateway(app_id);
        } else {
          toast.error("Application ID not found.");
        }
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("Error submitting form. Please try again.");
    } finally {
      setIsLoading(false);
      setLoading(false);
    }
  };

  const handleBackButton = () => {
    setActiveTab("form");
    onBack(files);
  };

  const validateForm = () => {
  

    const requiredFiles = ["passportCopy", "photo1", "photo2"];
    for (let file of requiredFiles) {
      if (!files[file]) {
        const element = document.querySelector(`[name="${file}"]`);
        if (element) {
          element.focus();
          element.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        toast.error(
          `Please upload ${file.replace(/([A-Z])/g, " $1").toLowerCase()}`
        );
        return false;
      }
    }
    return true;
  };

  const truncateFileName = (fileName, maxLength = 20) => {
    if (!fileName) return "";
    if (fileName.length <= maxLength) return fileName;
    const extension = fileName.split(".").pop();
    const nameWithoutExt = fileName.substring(0, fileName.lastIndexOf("."));
    const truncatedName = nameWithoutExt.substring(
      0,
      maxLength - extension.length - 4
    );
    return `${truncatedName}...${extension}`;
  };

  const handleRemoveFile = (fieldName) => {
    setFiles({
      ...files,
      [fieldName]: null,
    });
    // Reset the file input
    const fileInput = document.getElementById(fieldName);
    if (fileInput) {
      fileInput.value = "";
    }
  };

  const listStyle = {
    minWidth: "130px",
    fontWeight: "600",
  };

  const uploadButton = {
    backgroundColor: "#204974",
    color: "#fff",
    padding: "8px",
    display: "inline-block",
    paddingLeft: "15px",
    paddingRight: "15px",
    borderRadius: "5px",
  };

  return (
    <Fragment>
      <div className="container-fluid mt-5">
        <div className="row justify-content-center">
          <div className="col-md-12">
            <div className="row mb-2">
              <div className="col-lg-6 col-md-6 text-start">
                <h2>Application Summary</h2>
              </div>
              <div className="col-lg-6 col-md-6 text-right">
                <h2>ملخص الطلب</h2>
              </div>
            </div>

            <div className="inside_visa-form mb-5">
              {/* Personal Information */}
              <div className="mb-4">
                <h5 className="mb-3" style={{ color: "#204974" }}>
                  Personal Information
                </h5>
                <div className="row">
                  <div className="col-md-6">
                    <div className="d-flex flex-wrap mb-2">
                      <span className="fw-bold" style={listStyle}>
                        Full Name
                      </span>
                      <span>:&nbsp;</span>
                      <span className="ms-2">{formData?.fullName}</span>
                    </div>
                    <div className="d-flex flex-wrap mb-2">
                      <span className="fw-bold" style={listStyle}>
                        Nationality
                      </span>
                      <span>:&nbsp;</span>
                      <span className="ms-2">{formData?.nationality}</span>
                    </div>
                    <div className="d-flex flex-wrap mb-2">
                      <span className="fw-bold" style={listStyle}>
                        Date of Birth
                      </span>
                      <span>:&nbsp;</span>
                      <span className="ms-2">{formData?.dateOfBirth}</span>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="d-flex flex-wrap mb-2">
                      <span className="fw-bold" style={listStyle}>
                        Gender
                      </span>
                      <span>:&nbsp;</span>
                      <span className="ms-2">{formData?.gender}</span>
                    </div>
                    <div className="d-flex flex-wrap mb-2">
                      <span className="fw-bold" style={listStyle}>
                        Email
                      </span>
                      <span>:&nbsp;</span>
                      <span className="ms-2">{formData?.email}</span>
                    </div>
                    <div className="d-flex flex-wrap mb-2">
                      <span className="fw-bold" style={listStyle}>
                        Origin Mobile
                      </span>
                      <span>:&nbsp;</span>
                      <span className="ms-2">
                        {formData?.originMobileCode +
                          " " +
                          formData?.originMobile || ""}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Passport Information */}
              <div className="mb-4">
                <h5 className="mb-3" style={{ color: "#204974" }}>
                  Passport Information
                </h5>
                <div className="row">
                  <div className="col-md-6">
                    <div className="d-flex flex-wrap  flex-wrap mb-2">
                      <span className="fw-bold" style={listStyle}>
                        Passport Number
                      </span>
                      <span>:&nbsp;</span>
                      <span className="ms-2">{formData?.passportNumber}</span>
                    </div>
                    <div className="d-flex flex-wrap mb-2">
                      <span className="fw-bold" style={listStyle}>
                        Issue Date
                      </span>
                      <span>:&nbsp;</span>
                      <span className="ms-2">
                        {formData?.passportIssueDate}
                      </span>
                    </div>
                    <div className="d-flex flex-wrap mb-2">
                      <span className="fw-bold" style={listStyle}>
                        Expiry Date
                      </span>
                      <span>:&nbsp;</span>
                      <span className="ms-2">
                        {formData?.passportExpiryDate}
                      </span>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="d-flex flex-wrap mb-2">
                      <span className="fw-bold" style={listStyle}>
                        Country of Issue
                      </span>
                      <span>:&nbsp;</span>
                      <span className="ms-2">{formData?.countryOfIssue}</span>
                    </div>
                    <div className="d-flex flex-wrap mb-2">
                      <span className="fw-bold" style={listStyle}>
                        Place of Issue
                      </span>
                      <span>:&nbsp;</span>
                      <span className="ms-2">{formData?.placeOfIssue}</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Travel Information */}
              <div className="mb-4">
                <h5 className="mb-3" style={{ color: "#204974" }}>
                  Travel Information
                </h5>
                <div className="row">
                  <div className="col-md-6">
                    <div className="d-flex flex-wrap mb-2">
                      <span className="fw-bold" style={listStyle}>
                        Entry Date
                      </span>
                      <span>:&nbsp;</span>
                      <span className="ms-2">{formData?.entryDate}</span>
                    </div>
                    <div className="d-flex flex-wrap  mb-2">
                      <span className="fw-bold" style={listStyle}>
                        Stay Duration
                      </span>
                      <span>:&nbsp;</span>
                      <span className="ms-2">{formData?.stayDuration}</span>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="d-flex flex-wrap mb-2">
                      <span className="fw-bold" style={listStyle}>
                        Visa Type
                      </span>
                      <span>:&nbsp;</span>
                      <span className="ms-2">{formData?.visaType}</span>
                    </div>
                    <div className="d-flex flex-wrap mb-2">
                      <span className="fw-bold" style={listStyle}>
                        Oman Mobile
                      </span>
                      <span>:&nbsp;</span>
                      <span className="ms-2">
                        {formData?.omanMobileCode +
                          " " +
                          formData?.omanMobile || ""}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <button
                type="button"
                onClick={handleBackButton}
                className="px-4"
                style={{ borderRadius: "5px", margin: "0px" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ position: "relative", top: "2px" }}
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-pencil-square"
                  viewBox="0 0 16 16"
                >
                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                  <path
                    fillRule="evenodd"
                    d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                  />
                </svg>{" "}
                &nbsp; Edit
              </button>
            </div>

            {/* Requirements Section */}

            <div className="row mb-2">
              <div className="col-lg-6 col-md-6 text-start">
                <h2>Documents Required for Oman Tourist Visa</h2>
              </div>
              <div className="col-lg-6 col-md-6 text-right">
                <h2>
                  المستندات المطلوبة للحصول على تأشيرة سياحية إلى سلطنة عمان
                </h2>
              </div>
            </div>
            <div className="card mt-4 mb-4">
              <div className="card-body">
                <ul className="list-unstyled">
                  <li>
                    • Passport Copy (valid for 06 months from travel dates)
                  </li>
                  <li>
                    • Travel Insurance (we can arrange at additional cost)
                  </li>
                  <li>• 02 {"Photos"} (white background 5x5 cm)</li>
                  <li>• Visa Fee and Service Fees are non-refundable</li>
                </ul>
                <p
                  className="text-muted small mt-3 "
                  style={{ fontSize: "14px" }}
                >
                  <strong>{"Note"}:</strong>{" "}
                  {`The grant or refusal of the visa is at the sole discretion of the Royal Oman Police.`}
                  {`SuperJet is not involved in the process nor liable for any delay or rejection.`}
                  {`The Royal Oman Police reserves the right to ask for further documentation.`}
                </p>
              </div>
            </div>

            <div className="inside_visa-form">
              <div className="mb-4">
                <h4
                  className="mb-3 d-flex align-items-center"
                  style={{ color: "#204974" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="currentColor"
                    className="bi bi-cloud-upload me-2"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"
                    />
                    <path
                      fillRule="evenodd"
                      d="M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3z"
                    />
                  </svg>
                  &nbsp;Upload Required Documents
                </h4>
                <p className="text-muted mb-4">
                  Please upload the following documents. Click on each card to
                  select your files.
                </p>
              </div>

              <div className="row g-4">
                <div className="col-lg-3 col-md-6 mb-4">
                  <div
                    className="upload-zone"
                    style={{
                      border: files.passportCopy
                        ? "2px solid #28a745"
                        : "2px dashed #204974",
                      borderRadius: "15px",
                      padding: "20px 15px",
                      textAlign: "center",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      backgroundColor: "#f8fff9",
                      minHeight: "150px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                    }}
                    onClick={() => handleClickBtnFile(null, "passportCopy")}
                  >
                    <input
                      type="file"
                      name="passportCopy"
                      id="passportCopy"
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                      accept=".pdf,.jpg,.jpeg,.png"
                    />

                    {files.passportCopy ? (
                      <div>
                        <div className="d-flex justify-content-center mt-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            fill="#28a745"
                            className="bi bi-check2-circle"
                            viewBox="0 0 16 16"
                          >
                            <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0" />
                            <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" />
                          </svg>
                          &nbsp;
                          <h5 className="text-success mb-2 fw-bold ">
                            Passport Copy Uploaded
                          </h5>
                        </div>

                        <p className="text-muted mb-3 mt-3">
                          {truncateFileName(files.passportCopy.name, 30)}
                        </p>
                        <button
                          type="button"
                          className="btn btn-outline-danger btn-sm"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleRemoveFile("passportCopy");
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-trash me-1"
                            viewBox="0 0 16 16"
                            style={{ position: "relative", top: "3px" }}
                          >
                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                            <path
                              fillRule="evenodd"
                              d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                            />
                          </svg>
                          &nbsp; Remove
                        </button>
                      </div>
                    ) : (
                      <div>
                        <div className="d-flex justify-content-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            fill="#204974"
                            className="bi bi-file-earmark-text"
                            viewBox="0 0 16 16"
                            style={{ position: "relative", top: "2px" }}
                          >
                            <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z" />
                            <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                          </svg>
                          &nbsp;
                          <h5
                            className="mb-2 fw-bold"
                            style={{ color: "#204974" }}
                          >
                            Passport Copy <span className="text-danger">*</span>
                          </h5>
                        </div>
                        <p className="text-muted mb-3">
                          Click to upload your passport
                          <br />
                          PDF, JPG, PNG (Max 10MB)
                        </p>
                        <div style={uploadButton}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-upload me-2"
                            viewBox="0 0 16 16"
                          >
                            <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                            <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z" />
                          </svg>{" "}
                          &nbsp; Choose File
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 mb-4">
                  <div
                    className="upload-zone"
                    style={{
                      border: files.photo1
                        ? "2px solid #28a745"
                        : "2px dashed #204974",
                      borderRadius: "15px",
                      padding: "20px 15px",
                      textAlign: "center",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      backgroundColor: "#f8fff9",
                      minHeight: "150px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                    }}
                    onClick={() => handleClickBtnFile(null, "photo1")}
                  >
                    <input
                      type="file"
                      name="photo1"
                      id="photo1"
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                      accept=".jpg,.jpeg,.png"
                    />

                    {files.photo1 ? (
                      <div>
                        <div className="d-flex justify-content-center mt-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            fill="#28a745"
                            className="bi bi-check2-circle"
                            viewBox="0 0 16 16"
                          >
                            <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0" />
                            <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" />
                          </svg>
                          &nbsp;
                          <h5 className="text-success mb-2 fw-bold">
                            Photo 1 Uploaded
                          </h5>
                        </div>
                        <p className="text-muted mb-3 mt-3">
                          {truncateFileName(files.photo1.name, 30)}
                        </p>
                        <button
                          type="button"
                          className="btn btn-outline-danger btn-sm"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleRemoveFile("photo1");
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-trash me-1"
                            viewBox="0 0 16 16"
                            style={{ position: "relative", top: "3px" }}
                          >
                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                            <path
                              fillRule="evenodd"
                              d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                            />
                          </svg>
                          &nbsp; Remove
                        </button>
                      </div>
                    ) : (
                      <div>
                        <div className="d-flex justify-content-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            fill="#204974"
                            className="bi bi-file-earmark-text"
                            viewBox="0 0 16 16"
                          >
                            <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z" />
                            <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                          </svg>
                          &nbsp;
                          <h5
                            className="mb-2 fw-bold"
                            style={{ color: "#204974" }}
                          >
                            Photo 1(5x5 cm){" "}
                            <span className="text-danger">*</span>
                          </h5>
                        </div>
                        <p className="text-muted mb-3">
                          Click to upload your photo
                          <br />
                          JPG, PNG (Max 5MB)
                        </p>
                        <div style={uploadButton}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-upload me-2"
                            viewBox="0 0 16 16"
                            style={{ position: "relative", top: "2px" }}
                          >
                            <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                            <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z" />
                          </svg>{" "}
                          &nbsp; Choose File
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 mb-4">
                  <div
                    className="upload-zone"
                    style={{
                      border: files.photo2
                        ? "2px solid #28a745"
                        : "2px dashed #204974",
                      borderRadius: "15px",
                      padding: "20px 15px",
                      textAlign: "center",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      backgroundColor: "#f8fff9",
                      minHeight: "150px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                    }}
                    onClick={() => handleClickBtnFile(null, "photo2")}
                  >
                    <input
                      type="file"
                      name="photo2"
                      id="photo2"
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                      accept=".jpg,.jpeg,.png"
                    />

                    {files.photo2 ? (
                      <div>
                        <div className="d-flex justify-content-center mt-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            fill="#28a745"
                            className="bi bi-check2-circle"
                            viewBox="0 0 16 16"
                          >
                            <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0" />
                            <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" />
                          </svg>
                          &nbsp;
                          <h5 className="text-success mb-2 fw-bold">
                            Photo 2 Uploaded
                          </h5>
                        </div>
                        <p className="text-muted mb-3 mt-3">
                          {truncateFileName(files.photo2.name, 30)}
                        </p>
                        <button
                          type="button"
                          className="btn btn-outline-danger btn-sm"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleRemoveFile("photo2");
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-trash me-1"
                            viewBox="0 0 16 16"
                            style={{ position: "relative", top: "3px" }}
                          >
                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                            <path
                              fillRule="evenodd"
                              d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                            />
                          </svg>
                          &nbsp; Remove
                        </button>
                      </div>
                    ) : (
                      <div>
                        <div className="d-flex justify-content-center ">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            fill="#204974"
                            className="bi bi-file-earmark-text"
                            viewBox="0 0 16 16"
                          >
                            <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z" />
                            <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                          </svg>
                          &nbsp;
                          <h5
                            className="mb-2 fw-bold"
                            style={{ color: "#204974" }}
                          >
                            Photo 2 (5x5 cm){" "}
                            <span className="text-danger">*</span>
                          </h5>
                        </div>
                        <p className="text-muted mb-3">
                          Click to upload your photo
                          <br />
                          JPG, PNG (Max 5MB)
                        </p>
                        <div style={uploadButton}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-upload me-2"
                            viewBox="0 0 16 16"
                            style={{ position: "relative", top: "2px" }}
                          >
                            <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                            <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z" />
                          </svg>{" "}
                          &nbsp; Choose File
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 mb-4">
                  <div
                    className="upload-zone"
                    style={{
                      border: files.supportingDocs
                        ? "2px solid #28a745"
                        : "2px dashed #6c757d",
                      borderRadius: "15px",
                      padding: "20px 15px",
                      textAlign: "center",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      backgroundColor: "#f8fff9",
                      minHeight: "150px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                    }}
                    onClick={() => handleClickBtnFile(null, "supportingDocs")}
                  >
                    <input
                      type="file"
                      name="supportingDocs"
                      id="supportingDocs"
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                      accept=".pdf,.jpg,.jpeg,.png"
                      multiple
                    />

                    {files.supportingDocs ? (
                      <div>
                        <div className="d-flex justify-content-center mt-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            fill="#28a745"
                            className="bi bi-check2-circle"
                            viewBox="0 0 16 16"
                          >
                            <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0" />
                            <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" />
                          </svg>
                          &nbsp;
                          <h5 className="text-success mb-2 fw-bold">
                            Supporting Docs Uploaded
                          </h5>
                        </div>
                        <p className="text-muted mb-3 mt-3">
                          {truncateFileName(files.supportingDocs.name, 30)}
                        </p>
                        <button
                          type="button"
                          className="btn btn-outline-danger btn-sm"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleRemoveFile("supportingDocs");
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-trash me-1"
                            viewBox="0 0 16 16"
                            style={{ position: "relative", top: "3px" }}
                          >
                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                            <path
                              fillRule="evenodd"
                              d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                            />
                          </svg>
                          &nbsp; Remove
                        </button>
                      </div>
                    ) : (
                      <div>
                        <div className="d-flex justify-content-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            fill="#6c757d"
                            className="bi bi-files"
                            viewBox="0 0 16 16"
                          >
                            <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z" />
                          </svg>
                          &nbsp;
                          <h5 className="text-secondary mb-2 fw-bold">
                            Supporting Documents
                          </h5>
                        </div>
                        <p className="text-muted mb-3">
                          Optional additional files
                          <br />
                          PDF, JPG, PNG (Max 10MB)
                        </p>
                        <div style={uploadButton}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-files me-2"
                            viewBox="0 0 16 16"
                            style={{ position: "relative", top: "2px" }}
                          >
                            <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z" />
                          </svg>
                          &nbsp; Choose File
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 d-flex justify-content-center mt-4">
                <div
                  className="card "
                  style={{ borderRadius: "10px", width: "100%" }}
                >
                  {/* Gradient Header */}

                  <div className="card-body">
                    {/* Total Section */}
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <div className="d-flex align-items-center gap-2">
                        <i className="bi bi-cash-stack text-primary fs-4"></i>
                        <h6
                          className="text-secondary fw-semibold mb-0 "
                          style={{ fontSize: "20px", fontWeight: "600" }}
                        >
                          Total Amount
                        </h6>
                      </div>
                      <h2
                        className="text-dark mb-0"
                        style={{ fontWeight: "600" }}
                      >
                        45 OMR
                      </h2>
                    </div>
                  </div>
                </div>
              </div>

              {/* Payment Button */}

              <div className="col-12" style={{ marginBottom: "40px" }}>
                <div className="d-flex justify-content-between w-100 mt-4">
                  <div>
                    <button
                      type="button"
                      onClick={(e) => handleMakePayment(e)}
                      disabled={loading}
                      className=" px-5 "
                    >
                      {loading ? "Processing..." : "Submit" + " & " + "Pay"}
                    </button>
                  </div>
                </div>
              </div>
              <div className="mb-5">&nbsp;</div>
            </div>
          </div>
        </div>
      </div>

      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
      <ToastContainer position="top-right" autoClose={5000} />
    </Fragment>
  );
}

export default SanadOmanVisaSummary;
